<form [formGroup]="formCadastroPlano" (submit)="onCadastrar()">
  <breadcrumb [paginas]="[
    {route:'/home',name:'Home'},
    {route:'/parametros-periodo/cadastro-plano',name:'Cadastrar plano'}
  ]" />

  <section class="section-saudacao">
    <div class="container">
      <h2 class="titulo-page">Cadastrar plano</h2>
      <p class="descricao-page">Cadastre o plano que será usado na configuração de vigências.</p>
    </div>
  </section>

  <section class="conteudo-principal">
    <div class="container-conviva">
      <div class="time-line mx-w-900">
        <div class="section-filtro">
          <div class="container">
            <div class="grupo-filter-full">
              <label for="descricaoPlano">Plano</label>
              <input
                type="text"
                id="descricaoPlano"
                name="descricaoPlano"
                formControlName="descricaoPlano"
                class="input-text"
                [ngClass]="{ 'is-invalid': submitted && formCadastroPlano.get('descricaoPlano')?.errors }"
                aria-describedby="plano-error"
                maxlength="150" />
              <div *ngIf="submitted && formCadastroPlano.get('descricaoPlano')?.errors" class="alert alert-danger">
                <div *ngIf="formCadastroPlano.get('descricaoPlano')?.errors?.['required']">
                  * Plano é obrigatório
                </div>
                <div *ngIf="formCadastroPlano.get('descricaoPlano')?.errors?.['maxlength']">
                  * Plano deve ter no máximo 150 caracteres
                </div>
              </div>
            </div>

            <div class="container-btns">
              <input
                type="button"
                class="btn_outline"
                id="btnLimpar"
                name="btnLimpar"
                value="Limpar"
                aria-label="Limpar"
                (click)="onLimpar()" />

              <input
                type="submit"
                class="btn_primary"
                value="Cadastrar"
                aria-label="Cadastrar" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</form>
